module.exports = __webpack_public_path__ + "img/PADDYPOWER.fba92c74.svg";